import { svg } from "config/svgStyles";

export const gridLayout = ({ isMobile }) => ({
  height: "100%",
  display: "grid",
  gridTemplateColumns: "1fr",
  gridTemplateRows: isMobile ? "2fr minmax(0, 1fr) 60px" : "1fr 180px",
  gap: "0px 0px",
});

export const productContainer = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  position: "relative",
};

export const productDetailsContainer = ({ isDesktop }) => ({
  height: "0px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  alignItems: "flex-start",
  position: "relative",
  zIndex: 40,
  px: "40px",
  pt: isDesktop ? "106px" : "20px",
});

export const productDetailsHeader =
  ({ backgroundColour = "black" }) =>
  ({ isMobile }) => ({
    height: isMobile ? "50px" : "70px",
    width: "100%",
    background: backgroundColour,
    zIndex: 40,
    color: "white",
    px: "20px",
  });

export const productDetailsContainerAnimated = {
  height: "0px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  alignItems: "flex-start",
  width: "100%",
};

export const productDetails = {
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
};

export const costwithskate = {
  marginBottom: "20px",
  py: "0",
};

export const vertical = {
  stroke: "grey",
  strokeWidth: "2",
};

export const line = {
  height: "22",
  width: "20",
};

export const standaloneLearnPage = ({ isDesktop }) => ({
  variant: isDesktop ? "text.h4Light" : "text.h6Light",
  textTransform: "capitalize",
  lineHeight: "1",
  color: "#009CDA",
  background: "transparent",
  border: "none",
  padding: "0",
  px: "13px",

  "&:hover, &:focus": {
    background: "none",
    color: "#009CDA",
  },
});

export const productName =
  ({ categoryColor = "grey8" }) =>
  ({ isDesktop }) => ({
    variant: isDesktop ? "text.h4" : "text.h5",
    lineHeight: "1",
    marginBottom: isDesktop ? "10px" : "4px",
    position: "relative",
    fontWeight: "body",

    "&:before": {
      backgroundColor: categoryColor,
      content: "''",
      height: "6px",
      width: "20px",
      position: "absolute",
      top: "50%",
      left: "-40px",
      marginTop: "-3px",
      clipPath: "polygon(100% 0%, 90% 100%, 0% 100%, 0% 0%)",
    },
  });

export const cost = ({ isDesktop }) => ({
  variant: isDesktop ? "text.h4Light" : "text.h6Light",
  textTransform: "uppercase",
  lineHeight: "1",
  marginBottom: "20px",
  paddingRight: "10px",
});

export const changeProductButton = {
  marginBottom: "40px",
};

export const magnicationButtons = {
  marginTop: "auto",
};

export const productImageContainer = {
  position: "absolute",
  display: "flex",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  zIndex: 20,
};

export const addToOrderContainer = {
  height: "0",
  paddingBottom: "0",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  padding: "104px 40px 40px",
  position: "relative",
  zIndex: 40,
};

export const addToOrderButton = {
  mb: "20px",
};

export const shareButtonsContainer = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  mx: "-5px",
  mb: "20px",

  "> button": {
    mx: "5px",
  },
};

export const iconButton = {
  boxShadow: "0px 5px 10px rgba(0, 0, 0, 0.125)",
};

export const fixExpertDealerLocationButton = {
  boxShadow: "0px 5px 10px rgba(0, 0, 0, 0.125)",
};

export const loadingIndicatorContainer = {
  background: "rgba(255,255,255,.8)",
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  zIndex: 3000,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
};

export const customisationsContainer = ({ isDesktop }) => ({
  position: "relative",
  zIndex: 100,

  display: "grid",
  gridTemplateColumns: "1fr",
  gridTemplateRows: isDesktop ? "140px 40px" : "1fr",
});

export const bottomBarContainer = {
  position: "relative",
  zIndex: "100",
};

export const tabsContainer = {
  position: "absolute",
  zIndex: 40,
  bottom: "100%",
  left: 0,
  right: 0,
};

export const imageBadgesContainer = {
  mt: "40px",
};

export const personalizationNameContainer = {
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  userSelect: "none",
  pointerEvents: "none",
};

const rotateIcon = {
  position: "absolute",
  top: "75%",
  zIndex: "10000",
  cursor: "pointer",

  "&:hover": {
    svg: {
      ...svg("primary", "white"),
    },
  },
};

export const rotateRightIcon = {
  ...rotateIcon,
  left: "10%",
};

export const rotateLeftIcon = {
  ...rotateIcon,
  right: "10%",
};

export const notificationsContainer = {
  position: "absolute",
  top: 0,
  left: "50%",
  transform: "translateX(-50%)",
  zIndex: 100,
  maxWidth: "644px",
};

export const seeSimilarOptionsButton = {
  width: "100%",
  borderRadius: "0",
  borderTop: "1px solid white",
  zIndex: 20,
};
